/**
 * Status, filter, and display config for partners.
 */
import { Building2 } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { BadgeVariant } from '@/components/common/LabelBadge';

/** Badge + icon config for a partner type. */
export interface PartnerTypeConfig {
  label: string;
  icon: LucideIcon;
  badgeVariant: BadgeVariant;
  badgeColor: string;
}

/** Badge config for the partner entity. */
export const PARTNER_TYPE_CONFIG: PartnerTypeConfig = {
  label: 'Partenaire',
  icon: Building2,
  badgeVariant: 'ghost',
  badgeColor: 'var(--color-2-nuance-1)',
};

/** Interface-element name for partners. */
export const PARTNERS_MENU_ELEMENT_ID = 'partners';

/** Interface-element IDs for partner row actions. */
export const PARTNER_ACTION_IDS = {
  create: 'action-create-partner',
  view: 'action-view-partner',
  edit: 'action-edit-partner',
  delete: 'action-delete-partner',
  exportExcel: 'action-export-excel-partner',
} as const;

/** Filter element IDs for the partners {@link DataTable}. */
export const PARTNER_FILTER_IDS = {
  search: 'filter-search-partner',
  city: 'filter-city-partner',
} as const;

/** Partner list filter state. */
export interface PartnerFilters {
  search?: string;
  city?: string;
}
